'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _collection_utility = require('common-utilities/src/collection_utility');

var _functional_utility = require('../../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownComponent = function (_React$Component) {
    _inherits(DropdownComponent, _React$Component);

    function DropdownComponent(props) {
        _classCallCheck(this, DropdownComponent);

        return _possibleConstructorReturn(this, (DropdownComponent.__proto__ || Object.getPrototypeOf(DropdownComponent)).call(this, props));
    }

    _createClass(DropdownComponent, [{
        key: 'toggle',
        value: function toggle(isArrowIconClicked) {
            var _props = this.props,
                openDropdown = _props.openDropdown,
                onHideDropdown = _props.onHideDropdown,
                onShowDropdown = _props.onShowDropdown,
                dropdownContent = _props.dropdownContent,
                alwaysOpenOnSelect = _props.alwaysOpenOnSelect,
                onOpenDropdownCallback = _props.onOpenDropdownCallback;


            if (_collection_utility.CollectionUtility.size(dropdownContent) < 1) {
                return null;
            }

            if (openDropdown && (isArrowIconClicked || !alwaysOpenOnSelect)) {
                onHideDropdown();
            } else {
                onShowDropdown();
                if (typeof onOpenDropdownCallback === "function") {
                    onOpenDropdownCallback();
                }
            }
        }
    }, {
        key: 'getDownArrowClass',
        value: function getDownArrowClass() {
            var isShareClassDropDown = this.props.isShareClassDropDown;

            if (this.props.breakpoint < 3) {
                return isShareClassDropDown ? "npe-icon-down-arrow-white-bp2" : "npe-icon-down-arrow-bp2";
            } else {
                return isShareClassDropDown ? "npe-icon-down-arrow-white" : "npe-icon-down-arrow";
            }
        }
    }, {
        key: 'getUpArrowClass',
        value: function getUpArrowClass() {
            var isShareClassDropDown = this.props.isShareClassDropDown;

            if (this.props.breakpoint < 3) {
                return isShareClassDropDown ? "icon-up-arrow-white-bp2" : "icon-up-arrow-bp2";
            } else {
                return isShareClassDropDown ? "icon-up-arrow-white" : "icon-up-arrow";
            }
        }
    }, {
        key: 'renderDropDownArrow',
        value: function renderDropDownArrow(noDropdownContent, dropdownArrow) {
            if (noDropdownContent) {
                return null;
            }
            return _react2.default.createElement(
                'span',
                { className: dropdownArrow },
                ' '
            );
        }
    }, {
        key: 'focusOnFirstItem',
        value: function focusOnFirstItem() {
            var _this2 = this;

            setTimeout(function () {
                if (_this2.props.dropdownContent[0].ref !== null) {
                    _this2.props.dropdownContent[0].ref.current.focus();
                } else if (_this2.props.dropdownContent[0].props.children.ref !== null) {
                    if (_this2.props.dropdownContent[0].props.children.ref.current.attributes.hasOwnProperty('disabled')) {
                        _this2.props.dropdownContent[1].props.children[0].props.children.ref.current.focus();
                    } else {
                        _this2.props.dropdownContent[0].props.children.ref.current.focus();
                    }
                }
            }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                dropdownContent = _props2.dropdownContent,
                className = _props2.className,
                openDropdown = _props2.openDropdown,
                breakpoint = _props2.breakpoint,
                id = _props2.id,
                hideContent = _props2.hideContent,
                ariaLabel = _props2.ariaLabel,
                ariaLabelledby = _props2.ariaLabelledby;

            var parentWrapperClassName = 'dropdown-container ' + className + ' ' + (openDropdown ? "show" : "") + ' ' + (breakpoint < 3 ? "width-percent-100" : "");
            var noDropdownContent = _collection_utility.CollectionUtility.size(dropdownContent) < 1;
            var toggleableDropdownKeys = ["Enter", "Tab", " "];
            var openKeys = ['ArrowDown', 'ArrowUp', 'Enter'];

            var dropdownArrow = '' + (openDropdown ? this.getUpArrowClass() : this.getDownArrowClass());
            var onHoverStyle = {};

            if (noDropdownContent) {
                onHoverStyle = { "cursor": "auto" };
            }

            var dropDownClassName = this.props.isHeader ? "dropdown-display-header" : "dropdown-display";
            dropDownClassName = this.props.isDocs ? dropDownClassName + "-docs" : dropDownClassName;
            dropDownClassName = this.props.id === "dropdownFXCategory" ? dropDownClassName + " fx-fund-type-dropdown-mobile" : dropDownClassName;

            return _react2.default.createElement(
                'div',
                {
                    id: id,
                    className: parentWrapperClassName,
                    'aria-label': ariaLabel,
                    'aria-labelledby': ariaLabelledby,
                    style: this.props.dropdownWidth && breakpoint >= 3 ? { "width": this.props.dropdownWidth } : {},
                    'data-testid': id + '-test',
                    tabIndex: '0',
                    'aria-describedby': id + '-listbox1-1',
                    'aria-expanded': openDropdown ? "true" : "false",
                    'aria-haspopup': 'listbox',
                    role: 'combobox',
                    ref: this.props.setRefDropdown,
                    onKeyDown: function onKeyDown(e) {
                        if (openKeys.indexOf(e.key) > -1 && !openDropdown) {
                            _this3.toggle(true);
                            _this3.focusOnFirstItem();
                        } else if (e.key === "Enter" && openDropdown) {
                            _this3.toggle(false);
                        }
                    }
                },
                _react2.default.createElement(
                    'div',
                    {
                        className: dropDownClassName + ' ' + (openDropdown ? "clicked" : ""),
                        'data-testid': this.props.dataTest,
                        style: onHoverStyle,
                        onClick: function onClick() {
                            _this3.toggle(true);
                        },
                        onKeyDown: function onKeyDown(e) {
                            if (toggleableDropdownKeys.indexOf(e.key) > -1 && !openDropdown) {
                                _this3.toggle(true);
                            } else if (toggleableDropdownKeys.indexOf(e.key) > -1 && openDropdown) {
                                _this3.toggle(false);
                            }

                            if (e.key !== "Tab") {
                                e.preventDefault();
                            }

                            if (e.key === "ArrowDown" && openDropdown) {
                                _this3.focusOnFirstItem();
                            } else if (e.key === "ArrowDown" && !openDropdown) {
                                _this3.toggle(true);
                            }
                        }
                    },
                    _react2.default.createElement(
                        'span',
                        {
                            'data-testid': 'dropdown-label',
                            ref: (0, _ramda.isNil)(this.props.setRef) ? function (div) {
                                _this3['dropdown-label-' + _this3.props.refSuffix] = div;
                            } : this.props.setRef,
                            className: '' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "body2", "disclaimer") + (this.props.isDocs ? " font-white" : "") + ' ' + (hideContent ? 'hide-content' : ''),
                            id: id + '-listbox1-1' },
                        _string_utility2.default.renderFormattedLabel(this.props.initialActiveSelect, this.props.initialActiveSelectTranslationKey, this.props.values)
                    ),
                    this.renderDropDownArrow(noDropdownContent, dropdownArrow)
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'dropdown-list', onClick: function onClick() {
                            _this3.toggle(false);
                        } },
                    _react2.default.createElement(
                        'div',
                        _extends({ 'data-testid': id }, !noDropdownContent ? { role: 'listbox' } : {}),
                        dropdownContent
                    )
                )
            );
        }
    }]);

    return DropdownComponent;
}(_react2.default.Component);

exports.default = DropdownComponent;